export default {
  hr: {
    menu: {
      profile: "Profil",
      performances: "Performance",
      hiring: "Einstellung",
      trainings: "Trainings",
      expenses: "Ausgaben",
      imprests: "Zahlstellen",
      papers: "Papiere",
      documents: "Dokumente",
      health: "Gesundheit",
      debit_tickets: "Debit Tickets",
      payroll: "Gehaltsabrechnungen",
      payslip_explanation: "Payslip Explanation",
      events: "Events",
      approvals: "Approval Requests",
      expense_approval: "Zahlungsanträge",
      imprest_approval: "Zahlstellenanträge",
      messages: "Nachrichten",
      inbox: "Posteingang",
      outbox: "Postausgang",
      suggestions: "Vorschläge",
      notes: "Notizen",
      travels: "Reisen",
      travel_requests: "Reiseantrag",
      vehicles: "Fahrzeuge",
      menus: "Essensmenü",
      contact: "Kontakt",
      expense: "Ausgaben",
      expense_request_history: "Zahlungsanträge Verlauf",
      imprest: "Zahlstellen",
      imprest_request_history: "Zahlstellenanträge Verlauf",
      travel: "Reisen",
      travel_request_history: "Reiseanträge Verlauf",
      debit_ticket_transfer_requests: "Debit Ticket Transfer Requests",
      training: "Training",
      training_requests: "Training Requests",
      training_request_history: "Training Request History",
      survey: "Survey",
      pending_surveys: "Pending Surveys",
      completed_surveys: "Completed Surveys",
      my_team: "My Team"
    },
    account: {
      overview: "Übersicht",
      email: "E-Mail",
      information: "Informationen",
      profile: "Profil",
      language_role: "Language & Role",
      contact: "Kontakt",
      personal: "persönlich",
      family: "Familie",
      education: "Bildungsweg",
      employment: "Beschäftigung",
      financial: "finanziell",
      social_media: "Social Media",
      body_size: "Body Size",
      mobile_device: "Mobile Devices",
      special_fields: "besondere Tätigkeiten",
      messages: "Nachrichten",
      notes: "Notizen",
      management: "Management"
    },
    employee: {
      overview: {
        staff_number: "Personalnummer",
        branch: "Bereich",
        unit: "Unit",
        team: "Team",
        email: "E-Mail",
        job_info: "Jobinformation",
        leave: {
          manager: "Manager - Urlaub",
          managers: "Manager - Urlaub",
          approver: "Genehmigung - Urlaub"
        },
        hired_date: "Datum Beschäftigungsbeginn",
        status: "Status",
        manager: "Manager",
        shift_manager: "Shift Manager",
        shift_managers: "Shift Managers",
        role: "Rolle"
      },
      information: {
        identity_number: "Identitätsnummer",
        first_name: "Vorname",
        last_name: "Nachname",
        work_email: "Geschäftsemail",
        phone: "Telefon",
        email_and_sms_send_question: "E-Mail und SMS-Benachrichtigungen erhalten?"
      },
      profile: {
        identity_number: "Identitätsnummer",
        first_name: "Vorname",
        last_name: "Nachname",
        work_email: "Geschäftsemail",
        phone: "Telefon",
        email_and_sms_send_question: "E-Mail und SMS-Benachrichtigungen erhalten?",
        service_line: "Service Line"
      },
      language_role: {
        language: "Sprache",
        role: "Rolle"
      },
      contact: {
        email: "E-Mail",
        address: "Adresse",
        secondary_phone: "Zweittelefon",
        fixed_phone: "festes Telefon",
        work_phone: "Arbeitstelefon",
        spouse_phone: "Telefon des Partners",
        extension_number: "Durchwahlnummer",
        emergency_contact_name: "Notfallkontakt Name",
        emergency_contact_phone: "Notfallkontakt Telefon"
      },
      personal: {
        pasaport_number: "Reisepassnummer",
        birth_date: "Geburtsdatum",
        place_of_birth: "Geburtsort",
        nationality: "Nationalität",
        blood_type: "Blutgruppe",
        gender: "Geschlecht",
        disability_level: "Behinderungsgrad",
        ex_convict: "ehemaliger Häftling",
        driver: "Fahrer",
        military_service: "Militärdienst",
        suspended_until: "suspendiert bis",
        hes_code: "HES Code",
        hes_expired_date: "HES Code Expired Date"
      },
      family: {
        marital_status: "Beziehungsstatus",
        spouse_name: "Name des Ehepartners",
        child_count: "Anzahl Kinder",
        tenant: "Mieter",
        martyrs_relatives: "Märtyrer-Verwandte",
        disability_child_count: "Anzahl Kinder mit Behinderung",
        date_of_marriage: "Date of Marriage",
        father_name: "Father Name",
        mother_name: "Mother Name",
        mothers_maiden_name: "Mother's Maiden Name",
        sibling_count: "Sibling Count",
        child_info: "Child Info",
        add_child_info: "Add Child Info"
      },
      education: {
        graduation: "Abschluss",
        school: "Schule",
        faculty: "Fakultät",
        department: "Abteilung",
        graduation_grade: "Abschlussnote",
        academic_title: "akademischer Titel",
        languages: "Sprachen",
        license_file: "License File"
      },
      employment: {
        staff_number: "Personalnummer",
        branch: "Bereich",
        unit: "Unit",
        team: "Team",
        job_info: "Jobinformation",
        manager: "Manager",
        agency: "Agentur",
        ssn: "SSN",
        passive: "passiv",
        hired_date: "Startdatum der Beschäftigung",
        started_date: "Startdatum der Beschäftigung",
        employment_type: "Art der bBschäftigung",
        collar_type: "Collar Type",
        quite_job: "Kündigung",
        quit_job_reason: "Kündigungsgrund",
        quit_job_reason_description: "Beschreibung",
        description: "Beschreibung",
        quit_job_date: "Datum der Kündigung",
        have_an_interview_made: "Interview ja",
        have_an_interview_made_not: "Interview nein",
        research_and_development_person: "R&D Employee",
        social_security_type: "Social Security Type",
        trial_time: "Trial period",
        trial_time_hint: "* Trial period notifications are added on the basis of the recruitment date.",
        trial_time_title: "Trial period information",
        trial_time_item: "Information will be given on <strong>{0}</strong>",
        license_file: "License File",
        integration_value: "Integration Number",
        company: "Company",
        allowance_date: "Allowance Started Date"
      },
      financial: {
        iban: "IBAN",
        ticket_number: "Ticketnummer",
        bank_account_number: "Bankleitzahl",
        bank_branch: "Bank Bereich",
        salary: "Gehalt",
        ticket_price: "Ticketpreis",
        previous_salary: "Previous Salary",
        previous_ticket_price: "Previous Ticket Price",
        yearly_premium: "Yearly Premium",
        monthly_stoppage: "Monthly Stoppage",
        health_insurance_person_count: "Health Insurance Person Count",
        agi: "Minimum Living Allowance",
        gross_salary: "Gross Salary",
        pay_to_net: "Net Salary",
        pay_to_gross: "Gross Salary",
        salary_type: "Salary Payment Type"
      },
      social_media: {
        facebook: "Facebook",
        twitter: "Twitter",
        instagram: "Instagram",
        linkedin: "Linkedin",
        skype: "Skype"
      },
      body_size: {
        weight: "Gewicht",
        height: "Größe",
        shirt_size: "Hemdgröße",
        pants_size: "Hosengröße",
        shoe_size: "Schuhgröße",
        waistcoat: "Waistcoat",
        coat: "Coat"
      },
      management: {
        manager: "Manager",
        leave_managers: "Manager - Urlaube",
        shift_managers: "Manager - Dienstpläne",
        overtime_managers: "Manager - Überstunden",
        expense_managers: "Manager – Ausgaben"
      },
      mobile_device: {
        serial_number: "Serial Number",
        multiple_device_allowed: "Multiple Device Allowed"
      }
    },
    performance: {
      results: {
        evaluatee: "Gutachter:In",
        published_evaluators: "veröffentlichte Gutachter:Innen",
        unpublished_evaluators: "nicht veröffentlichte Gutachter:Innen",
        kpi_score: "Kpi Score",
        competence_score: "Kompetenz-Score",
        totalCount: "Total Teilnehmeranzahl",
        publishedCount: "active Teilnehmer",
        evaluation_name: "Name des Gutachtens",
        total_score: "Total Score",
        status: "Status",
        period: "Zeit",
        scoring: "Scoring",
        beginDate: "Startdatum",
        endDate: "Enddatum"
      },
      table: {
        name: "Name",
        type: "Performance Typ",
        score_range: "Score Reichweite",
        evaluatee: "Gutachter:In",
        expiration_period: "Auslaufdatum",
        validation_period: "Gültigkeitsdatum",
        status: "Bewertungsstatus",
        categories: "Kategorien"
      },
      depths: {
        depth_1: "1. Level",
        depth_2: "2. Level",
        depth_3: "3. Level",
        depth_4: "4. Level",
        depth_5: "5. Level"
      },
      add: {
        kpi: "KPI hinzufügen",
        competence: "Kompetenz hinzufügen",
        pool: "Aus dem Pool wählen",
        custom: "Neu hinzufügen",
        kpi_group: "KPI-Gruppe hinzufügen",
        competence_group: "Kompetenz-Gruppe hinzufügen",
        evaluation: "Add Evaluation Plan"
      },
      detail: {
        kpi_group: "KPI-Gruppe Details",
        competence_group: "Kompetenz-Gruppe Details"
      },
      crud: {
        detail: {
          template: "Template Details",
          evaluation: "Bewertungsplan Details"
        }
      },
      type: {
        KPI: "KPI",
        COMPETENCE: "Kompetenz"
      },
      validation: {
        add_item: "Der Kategorie {0} müssen Fragen hinzugefügt werden",
        template_exist_category: "Kategorie {0} wurde hinzugefügt",
        template_must_a_category: "Es muss mindestens eine Kategorie im Performance Template vorhanden sein",
        question_total_weight_required: "Die Gesamtgewichtung der Fragen muss bei {0}% liegen",
        question_total_weight: "Gesamtgewichtung der Fragen: {0}%",
        category_not_exist: "Diese Kategorie existiert nicht",
        category_total_weight_equals_in_questions:
          "Da die Gewichtung der Kategorie {0} {1}% der Gesamtgewichtung der Fragen beträgt, muss diese Kategorie {1}% entsprechen",
        category_in_question_required: "Kategorie {0} muss mindestens eine Frage beinhalten",
        question_weight_required: "Geben Sie die Gewichtung {0} an"
      },
      information:
        '<p class="body-1 mt-5">' +
        "Durch anklicken der KPI- & KOMPETENZkategorien können Sie KIP- und Kompetenzlisten." +
        "</p>" +
        '<p class="body-1">' +
        "Sie können eine auf die Fragen basierte Bewertung vornehmen, indem Sie die Gewichtung der KPI- und Kompetenzfragen in deren entsprechenden Kategorien angeben " +
        "</p>" +
        '<p class="body-1">' +
        "Die Gesamtsumme der Fragen sollte der Gesamtgewichtung der KPI und Kompetenz aus Ihrer Liste entsprechen." +
        "</p>",
      total_evaluatees_count: "Gesamtanzahl der Gutachter:Innen {0}",
      waiting_evaluates_finish: "{0} Person(en) warten auf ein Gutachten",
      complete_evaluation: "Dieses Gutachten wurde abgeschlossen",
      expiration_date: "Auslaufdatum",
      template_name: "Template Name",
      kpi: "KPI",
      kpi_category: "KPI Kategorie",
      kpis: "KPIs",
      competence: "Kompetenzen",
      competence_category: "Kompetenzkategorie",
      competences: "Kompetenzen",
      result_view: "Ergebnisse anzeigen",
      waiting: "in Bearbeitung",
      hourly: "stündlich",
      weekly: "wöchentlich",
      monthly: "monatlich",
      yearly: "jährlich",
      score: "Score",
      star: "Star",
      weight: "Gewicht",
      point: "Punkt",
      person: "Person",
      persons: "Personen",
      period_type: "Periode",
      score_type: "Score Typ",
      score_min_count: "minimaler Score",
      score_max_count: "maximaler Score",
      evaluation: "Aufgabe",
      evaluates: "Gutacher:Innen",
      evaluators: "Gutachter:In",
      self: "Ich",
      superior: "vorgesetzt",
      subordinates: "untergestellt",
      same: "gleich",
      flexible: "flexibel",
      period: "Periode",
      expiration_dates: "Auslaufdatum",
      expiration_begin_date: "Startdatum des Auslaufzeitraumes",
      expiration_end_date: "Enddatum des Auslaufzeitraumes",
      level: "Level",
      depth: "Tiefe",
      validation_date: "Validierungsdatum",
      validation_begin_date: "Beginndatum der Validierung",
      validation_end_date: "Enddatum der Validierung",
      published_date_time: "Datum der Veröffentlichtung",
      degree_360: "360 °",
      m2m: "M2M",
      published: "Start des Gutachtens",
      published_start: "Gutachten starten",
      evaluation_done: "Gutachten abschließen",
      are_you_sure: "Sind Sie sicher?",
      are_you_text: "Möchten Sie das Gutachten starten??",
      performance_item: {
        title: "Performance"
      },
      my_evaluatees: "meine Gutachter",
      my_evaluated: "meine Gutachten"
    },
    training: {
      plan: "Trainingsplan",
      name: "Trainingsname",
      type: "Trainingstyp",
      organizer: "Zuständige:r",
      lecturer: "Dozent:In",
      terminal: "Terminal",
      sessions: "Sitzungen",
      session: "Sitzung",
      training_type: {
        ONLINE: "Online",
        CLASSROOM: "Seminarraum",
        ON_SITE: "vor Ort"
      },
      training_detail: "Trainingsdetails",
      location: "Standort",
      description: "Beschreibung",
      training: "Training",
      request_training: "Request a Training",
      training_requests: "Training Requests",
      request_date: "Request Date",
      abolisher: "Abolisher",
      approval_history: "Approval History",
      cancelled_date: "Cancelled Date",
      hr_manager: "HR Manager",
      approval_date: "Approval Date",
      cancel_request: "Cancel Request",
      cancellation_note: "Cancellation note?",
      request_cancellation_process: "Training Request Cancellation Process",
      request_approval_process: "Training Request Approval Process",
      denied: "Deny",
      approved: "Approve",
      training_planned: "Is Training Planned"
    },
    expense: {
      name: "Kosten: Name",
      type: "Kosten: Typ",
      amount: "Kostenhöhe",
      date: "Datum der Anforderung",
      status: "Status",
      attachment: "Anhang",
      create_expense: "Ausgabenantrag stellen",
      travel: "Reise",
      approved_amount: "Höhe der Ausgaben wurde bestätigt"
    },
    imprest: {
      amount: "Menge",
      period: "Zeitraum der Zahlstelle",
      reason: "Grund",
      status: "Status",
      create_imprest: "Zahlstellenantrag stellen",
      travel: "Reise",
      approved_amount: "Höhe der Zahlstelle wurde bestätigt",
      date: "Datum"
    },
    paper: {
      type: "Papiertyp",
      name: "Dokumentenname",
      issue_date: "Ausgabedatum",
      expire_date: "Auslaufdatum",
      signature_status: "Signatur-Status",
      signature_types: {
        NOT_REQUIRED: "nicht benötigt",
        STANDARD_SIGNATURE: "Standardsignatur",
        BIOMETRIC_SIGNATURE: "Biometrische Signatur",
        SIGNED: "unterschrieben",
        null: "-",
        E_SIGNATURE: "E-Signatur"
      },
      add_paper: "Dokument hinzufügen",
      papers: {
        issue_date: "Ausgabedatum",
        expire_date: "Auslaufdatum"
      }
    },
    document: {
      name: "Dokumentenname",
      type: "Dokumententyp",
      sender: "Sender",
      date: "Datum",
      add_document: "Dokument hinzuüfgen",
      mobile_accessible_disable: "mobil erreichbar – deaktivieren",
      mobile_accessible_enable: "mobil erreichbar – aktivieren"
    },
    health: {
      name: "Name",
      category: "Kategorie",
      from: "Startdatum",
      to: "Enddatum",
      disease_detail: "Gesundheitsdetails",
      importance: "Priorität",
      importance_enum: {
        LOW: "gering",
        MEDIUM: "normal",
        HIGH: "hoch"
      },
      medicines: "Medikamente und Antibiotika",
      attachment: "Anhang",
      description: "Beschreibung"
    },
    debit_tickets: {
      asset: "Asset",
      borrow_date: "Ausleihdatum",
      due_date: "Abgabedatum",
      give_back_date: "Frist",
      quantity: "Anzahl",
      transfer: "Transfer",
      transfer_approval: "Übertragung Genehmigung",
      approver: "Mitarbeiter, der versetzt werden soll",
      debit_transfer: "Debit Ticket Transfer",
      download_form: "Formular herunterladen"
    },
    payroll: {
      month: "Monat",
      created_date: "Erstelldatum",
      file: "Datei"
    },
    events: {
      name: "Name",
      type: "Typ",
      owner: "Besitzer",
      online: "Online",
      begin_date: "Startdatum",
      end_date: "Enddatum",
      activity: "Aktivität"
    },
    expense_approval: {
      employee: "Mitarbeiter",
      description: "Beschreibung",
      amount: "Menge",
      status: "Status",
      request_date: "Antragsdatum",
      document: "Dokument",
      expense_approval: "Kostenbestätigung",
      message:
        "{0} hat eine Kostenanfrage in Höhe von <b>{3}</b> <b>{2}</b> on <b>{1}</b> beantragt. Möchten Sie dies bestätigen?"
    },
    imprest_approval: {
      employee: "Mitarbeiter",
      amount: "Menge",
      status: "Status",
      request_date: "Antragsdatum",
      imprest_approval: "Zahlstellenantrag",
      message:
        "{0} hat einen Zahlstellenantrag in Höhe von <b>{2}</b> <b>{1}</b> beantragt. Möchten Sie dies bestätigen?"
    },
    hiring: {
      job_posting: "Stellenanzeige",
      applicant: "Bewerber:In",
      applicants: "Bewerber:Innen",
      interview: "Interview",
      assessment_date: "Bewertungsdatum",
      working_date: "Arbeitsdatum",
      last_job: "letzte Beschäftigung",
      last_position_level: "letzte Position",
      evaluator: "Gutachter:In",
      evaluators: "Gutachter:Innen",
      weight: "Gewicht",
      link: "Link",
      skill: "Fähigkeiten",
      rate: "Rate",
      rating: "Bewertung",
      table: {
        applicant: "Bewerber:In",
        job_posting: "Stellenanzeige",
        last_job: "letzte Beschäftigung",
        assessment: "Aufgabe",
        rating: "Bewertung",
        assessment_date: "Bewertungsdatum",
        status: "Status",
        evaluators: "Gutachter:Innen",
        evaluator: "Gutachter:In"
      },
      skill_type: {
        soft: "soft",
        technical: "technisch",
        question: "Frage",
        link: "Link"
      }
    },
    message: {
      message_type: "Nachrichtentyp",
      sender: "Sender",
      receivers: "Empfänger",
      importance: "Priorität",
      title: "Titel",
      body: "Body",
      whom: "An wen?",
      date: "Datum",
      message_type_enum: {
        EMAIL: "E-mail",
        SMS: "Sms",
        IN_APP: "Benachrichtigung"
      },
      message_importance_enum: {
        LOW: "niedrig",
        MEDIUM: "normal",
        HIGH: "hoch"
      },
      send_message: "Nachricht senden",
      success_message: "{1} gesendet an {0} Personen | {1} gesendet an {0} Personen"
    },
    suggestion: {
      category: "Empfehlungskategorie",
      title: "Empfehlungen",
      add_suggestion: "Empfehlung hinzufügen",
      body: "Nachricht"
    },
    note: {
      notes: "Notizen",
      title: "Titel",
      body: "Body",
      attachment: "Anhang",
      description: "Beschreibung",
      add_note: "Notiz hinzufügen",
      owner: "Mitarbeiter",
      importance: "Priorität"
    },
    travel: {
      request_travel: "Reiseantrag erstellen",
      leave_request: "Urlaubsantrag stellen",
      travels: "Reisen",
      travel: "Reise",
      travel_detail: "Reisedetail",
      start_work_date: "Startdatum Arbeit",
      is_domestic: "inländische Reise?",
      country: "Land",
      city: "Stadt",
      region: "Region",
      is_rent_car: "Mietwagen?",
      is_shuttle: "Shuttle?",
      description: "Beschreibung",
      reason: "Grund",
      status: "Status",
      expense_message:
        "<strong>{0}</strong> hat beantragt, <strong>{4}</strong> auszugeben für <strong>{3}</strong> am <strong>{2}</strong> in <strong>{1}</strong>",
      imprest_message:
        "<strong>{0}</strong> hat eine Vorauszahlung von <strong>{2}</strong> für <strong>{1}</strong> beantragt",
      subsistence_message:
        "Der Mitarbeiter <strong>{0}</strong> hat eine Pauschalsumme von <strong>{2}</strong> für <strong>{1}</strong> erhalten",
      travel_dates: "Reisedaten",
      pending_travel_approvals: "Reisebestätigung ausstehend",
      travel_process: "Reiseprozess",
      travel_details: "Reisedetails",
      no_detail_item: "Keine Details",
      add_new_detail: "Details hinzufügen",
      detail_type: "Detailtyp",
      detail_subtype: "Detailunterkategorie",
      travel_detail_type_enum: {
        TRANSFER: "Transfer",
        LAYOVER: "Layover",
        BUSINESS: "Business"
      },
      travel_detail_subtype_enum: {
        BUS: "Bus",
        PLANE: "Flugzeug",
        TRAIN: "Zug",
        SHIP: "Schiff",
        CAR: "Auto",
        HOTEL: "Hotel",
        HOSTEL: "Hostel",
        VILLA: "Villa",
        FACTORY: "Fabrik",
        OFFICE: "Office"
      },
      begin_date: "Startdatum",
      end_date: "Enddatum",
      expenses: "Kosten",
      imprests: "Zahlenstellen",
      debits: "Abbuchungen",
      borrow_date: "Leihdatum",
      due_date: "Frist",
      give_back_date: "Rückgabedatum",
      quantity: "Menge",
      name: "Name",
      category: "Kategorie",
      model: "Modell",
      subsistences: "Pauschalsumme",
      project: "Projekt",
      attrition: "Fluktuationsrate"
    },
    travel_request: {
      employee: "Mitarbeiter",
      begin_date: "Startdatum",
      end_date: "Enddatum",
      start_work_date: "Startdatum Arbeit",
      status: "Status",
      request_date: "Antragsdatum",
      travel_approval: "Reisebestätigung",
      message: "<b>{0}</b> hat einen Reiseantrag für <b>{1}</b> - <b>{2}</b> gestellt. Möchten Sie dies bestätigen?"
    },
    vehicle: {
      plate_number: "KFZ-Kennzeichen",
      brand: "Marke",
      model: "Modell",
      year: "Baujahr",
      branch: "Bereich",
      employee: "Mitarbeiter"
    },
    contact: {
      employee: "Mitarbeiter",
      email: "E-Mail",
      phone: "Telefon"
    },
    projects: {
      project: "Projekt",
      employee_count_message: "Keine Mitarbeiter | 1 Mitarbeiter | {count} Mitarbeiter"
    },
    debit_ticket_transfer_request: {
      requester: "Antragsteller",
      asset: "Anlagegut",
      approval_message:
        "<strong>{0}</strong> has requested to transfer the asset which has the following information to your embezzlement, do you want to confirm?"
    },
    survey: {
      name: "Survey Name",
      published_date: "Publish Date",
      end_date: "End Date",
      start_survey: "Start Survey",
      survey_privacy: "Survey Privacy",
      status: "Status",
      pending_title: "Surveys You Should Complete",
      completed_title: "Surveys I Participated",
      complete_survey: "Complete Survey",
      survey_information: "Survey Information",
      exit: "Exit",
      save_and_finish: "Save And Finish",
      status_enum: {
        completed: "Completed",
        continuous: "Continuous"
      },
      section_count: "Section Count",
      question_count: "Question Count",
      estimated_duration: "Estimated Duration",
      description: "Description",
      anonymous_on: "Closed Voting",
      anonymous_off: "Open Voting",
      enter_answer: "You can enter an answer",
      your_answer: "Your answer",
      please_select: "please select"
    },
    employees: {
      employee_profile: "Employee Profile",
      staffNumber: "Staff Number",
      email: "Email",
      branch: "Branch",
      unit: "Unit",
      team: "Team",
      jobInfo: "Job Ibfo",
      status: "Status",
      hiredDate: "Hired Date",
      birthDate: "Birth Date",
      manager: "Manager",
      hrManagers: "HR Managers",
      leaveManagers: "Time Off Managers",
      shiftManagers: "Shift Managers",
      overtimeManagers: "Overtime Managers",
      leaveAccruals: "Time Off Accruals",
      active: "Active",
      passive: "Passive",
      leaveType: "Time Off Name",
      accrualCount: "Time Off Accrual",
      leaveBalance: "Time Off Balance",
      used: "Used",
      previousBalance: "Previous Balance"
    }
  }
};
